import React from "react";
import { Link } from "react-router-dom";

interface Button {
  text: string;
  href: string;
  variant?: "primary" | "line";
}

interface InitiativeCardProps {
  image: string;
  imageAlt: string;
  title: string;
  description: string;
  buttons: Button[];
  tags?: string[];
}

const InitiativeCard: React.FC<InitiativeCardProps> = ({
  image,
  imageAlt,
  title,
  description,
  buttons = [
    {
      text: "Sign Up",
      href: "#initiative-utop-signup",
      variant: "primary" as const,
    },
    {
      text: "Know More",
      href: "/initiatives/utop",
      variant: "line" as const,
    },
  ],
  tags = [],
}) => {
  return (
    <div className="initiative-card">
      <div className="initiative-card-image">
        <img src={image} alt={imageAlt} />
      </div>
      <h4 className="text-center mb-3">{title}</h4>
      <p className="text-center mb-4">{description}</p>
      {tags.length > 0 && (
        <div className="blog-card__tags mb-4 text-center">
          {tags.map((tag, index) => (
            <Link 
              key={index} 
              className="tag" 
              to={`/tag/${encodeURIComponent(tag)}`}
            >
              {tag}
            </Link>
          ))}
        </div>
      )}
      <div className="text-center">
        {buttons.map((button, index) => {
          const isInternal = button.href.startsWith("/");
          const className = `btn-main ${
            button.variant === "line" ? "btn-line mx-2" : ""
          }`;
          return isInternal ? (
            <Link
              key={index}
              to={button.href}
              className={className}
            >
              <span>{button.text}</span>
            </Link>
          ) : (
          <a
            key={index}
              className={className}
            href={button.href}
          >
            <span>{button.text}</span>
          </a>
          );
        })}
      </div>
    </div>
  );
};

export default InitiativeCard;
